<template>
  <div :class="rootClasses">
    <component :key="index" v-for="(child,index) in blok.body" :blok="child" :is="child.component"></component>
  </div>
</template>
<script>
import Blok from "../components/Blok.vue";
import SummaryBlok from "../components/SummaryBlok.vue";
import Leader from "../components/Leader.vue";
import Slideshow from "../components/Slideshow.vue";
import RecipesContainer from "../components/RecipesContainer.vue";
import LibraryContent from "../components/LibraryContent.vue";
import NavBar from "../components/navigation/NavBar.vue";
import ShopifyProductsContainer from "../components/ShopifyProductsContainer";
import SimpleBasket from "../components/shopify/SimpleBasket";
import CustomCSS from "../components/CustomCSS";
import ShopifyDeliveryAlert from "../components/shopify/ShopifyDeliveryAlert.vue";
import ShopifyDeliveryNote from "../components/shopify/ShopifyDeliveryNote.vue";
import BasketNotifications from "../components/basket/BasketNotifications";

export default {
  name: "lander",
  props: ["blok"],
  components: {
    Blok,
    Leader,
    Slideshow,
    SummaryBlok,
    RecipesContainer,
    LibraryContent,
    'navigation-bar': NavBar,
    'shopify-container': ShopifyProductsContainer,
    'shopify-basket': SimpleBasket,
    'custom-css': CustomCSS,
    'shopify-delivery-alert': ShopifyDeliveryAlert,
    'basket-notifications' : BasketNotifications,
    'shopify-delivery-notes' : ShopifyDeliveryNote
  },
  computed: {
    rootClasses: function() {
      const b = this.$props.blok;
      return [  
        b.contain ? 'container' : 'container-fluid',     
        b.theme,
        b.component
      ];
    }
  }
};
</script>
